
import defaultSettings from '@/setting'

const {theZcBookPreviewUrl,theJcBookPreviewUrl,theRedirectBookPreviewUrl,theBusinessUrl } = defaultSettings

const state = {
    theZcBookPreviewUrl:theZcBookPreviewUrl,
    theJcBookPreviewUrl:theJcBookPreviewUrl,
    theRedirectBookPreviewUrl,
    theBusinessUrl: theBusinessUrl
}


export default {
    namespaced: true,
    state
}

